export class ResetGroupUsersList {
  public static readonly type = '[Group/GroupMember/List] ResetGroupUsersList';
}
